import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cribl = defineConnector({
  identifier: "cribl",
  name: "Cribl",
  tagLine: "Data pipeline and observability",
  logo,
  protocol: "http",
  tags: ["featured", "engineering"],
  defaultUrlPattern: () => "https://.*\\.cribl\\.cloud/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Cribl",
      items: [
        {
          kind: "markdown",
          content: `1. Log in to your [Cribl.Cloud](https://app.cribl.cloud) account
2. Navigate to **Access Management** and select **API Credentials**
3. Click **Add Credentials**
4. Enter a name (e.g., "3B") and select the appropriate permissions
5. Copy the **Client ID** and **Client Secret**`,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://login.cribl.cloud/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
    authorizationParameters: () => ({
      audience: "https://api.cribl.cloud",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.cribl.cloud/api/v1/info",
      method: "GET",
    }),
  },
});
